/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios'
import { useToast } from '@/Composables/useToast'

window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Globale 418/419-handler voor permissie-/licentie-denials op axios-calls vanuit
// reusable componenten (ProductSelector, EditCreateModal, ...). Voorheen gooide
// MenuAccessMiddleware een 418 die ongelogd in de console belandde of de user uit
// z'n flow joeg. Nu: korte toast tonen, de error doorlaten zodat de caller zelf
// graceful kan afhandelen, en NIET redirecten.
//
// Bewust NIET 403: 403 komt uit Policies, throttles en andere middleware die hun
// eigen UX/foutpagina hebben — een generieke "geen rechten"-toast zou daar
// misleidend zijn. 418 (MenuAccessMiddleware) en 419 (license-gate) zijn de
// statussen die specifiek door de permissie-laag worden gegooid.
//
// Inertia-requests worden geskipt via de X-Inertia header: Inertia gebruikt
// dezelfde axios-instance maar heeft eigen error-modal handling. useToast is een
// module-singleton (geen setup-context nodig), trans() loopt via vue-i18n nadat
// de app is gemount — interceptor fired pas op response, dus altijd ná mount.
//
// De aparte token-refresh interceptor in Services/api.ts blijft 401 afhandelen.
//
// Opt-out per request met `{ silentPermissionErrors: true }` (getypt in
// types/axios.d.ts): voor achtergrondcalls die de gebruiker niet zelf startte of die
// hun fout zelf tonen. Aanleiding: de globale zoekfunctie laadt en bewaart recente
// items stil, en toonde zonder licentie bij elk openen een licentie-toast bovenop de
// zoekmodal (GH #722 review).
const PERMISSION_DENIAL_STATUSES = new Set([418, 419])

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status
        const isInertia = Boolean(error?.config?.headers?.['X-Inertia'])
        const isSilent = error?.config?.silentPermissionErrors === true

        if (!isInertia && !isSilent && status && PERMISSION_DENIAL_STATUSES.has(status)) {
            const key =
                status === 419 ? 'errors.no_active_license' : 'errors.permission_denied_inline'
            useToast().warning(key)
        }

        return Promise.reject(error)
    }
)

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
